webpackJsonp([4],{

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_search_ViewSearch__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_search_ViewSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_search_ViewSearch__);




/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'search',
    component: __WEBPACK_IMPORTED_MODULE_2__views_search_ViewSearch___default.a
  }]
}));

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(163),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad93a978",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);





/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    handelClickPerson: function handelClickPerson(item) {
      window.location.href = "/detail.html#/person";
    },
    handelClickCompany: function handelClickCompany(item) {
      window.location.href = "/detail.html#/company";
    },
    handelClickJob: function handelClickJob(item) {
      window.location.href = "/detail.html#/job";
    },
    handelSelectSearchType: function handelSelectSearchType(type) {
      this.search_type = type;
    }
  },
  components: {
    'top-header': __WEBPACK_IMPORTED_MODULE_0__components_TopHeader___default.a,
    'foter': __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  },
  name: 'app',
  data: function data() {
    return {
      search_type: 1,
      search_user_result: [{
        user_name: '陈金亚',
        company: '欢聚时刻科技有限公司',
        job_name: '联合创始人'
      }, {
        user_name: '马继德',
        company: '欢聚时刻科技有限公司',
        job_name: '联合创始人'
      }, {
        user_name: '梁明一',
        company: '百度在线',
        job_name: 'PHP研发工程师'
      }],
      search_job_result: [{
        company: '欢聚时刻科技有限公司',
        job_name: 'PHP研发工程师',
        salary: '20k'
      }, {
        company: '欢聚时刻科技有限公司',
        job_name: '安卓研发工程师',
        salary: '20k'
      }, {
        salary: '20k',
        company: '百度在线',
        job_name: 'PHP研发工程师'
      }]

    };
  },

  created: function created() {}
});

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-header'), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "search-type"
  }, [_c('label', {
    class: _vm.search_type == 1 ? 'active' : null,
    on: {
      "click": function($event) {
        _vm.handelSelectSearchType(1)
      }
    }
  }, [_vm._v("找人")]), _vm._v(" "), _c('label', {
    class: _vm.search_type == 2 ? 'active' : null,
    on: {
      "click": function($event) {
        _vm.handelSelectSearchType(2)
      }
    }
  }, [_vm._v("找工作")])]), _vm._v(" "), _c('div', {
    staticClass: "search-wrap"
  }, [_c('input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": _vm.search_type == 1 ? '输入找人的姓名' : '输入要找的工作岗位'
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-btn"
  }, [_vm._v("搜索")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "search-list clearfix"
  }, _vm._l((_vm.search_user_result), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.handelClickPerson(item)
        }
      }
    }, [_c('div', {
      staticClass: "search-item"
    }, [_c('div', {
      staticClass: "search-item-title"
    }, [_vm._v("\n              " + _vm._s(item.user_name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "search-item-intro"
    }, [_vm._v("\n             " + _vm._s(item.company) + " - " + _vm._s(item.job_name) + "\n            ")])])])
  })), _vm._v(" "), _c('ul', {
    staticClass: "search-list clearfix"
  }, _vm._l((_vm.search_job_result), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.handelClickJob(item)
        }
      }
    }, [_c('div', {
      staticClass: "search-item"
    }, [_c('div', {
      staticClass: "search-item-title"
    }, [_vm._v("\n              " + _vm._s(item.job_name) + "\n              \n            ")]), _vm._v(" "), _c('div', {
      staticClass: "search-item-intro"
    }, [_vm._v("\n             \n             " + _vm._s(item.company) + " - " + _vm._s(item.salary) + "\n            ")])])])
  })), _vm._v(" "), _c('ul', {
    staticClass: "search-list clearfix"
  }, _vm._l((_vm.search_job_result), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.handelClickCompany(item)
        }
      }
    }, [_c('div', {
      staticClass: "search-item"
    }, [_c('div', {
      staticClass: "search-item-title"
    }, [_vm._v("\n              " + _vm._s(item.company) + " - " + _vm._s(item.salary) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "search-item-intro"
    }, [_vm._v("\n             \n             " + _vm._s(item.job_name) + "\n            ")])])])
  }))]), _vm._v(" "), _c('foter')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(43),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5343dbb6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(39)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(42),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-142c7db0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  computed: {
    user_info: function user_info() {
      return this.$store.state.user_info;
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-header"
  }, [_c('div', {
    staticClass: "paraller"
  }, [_c('div', {
    staticClass: "container   clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "top-side"
  }, [_c('ul', [_c('li', {
    staticClass: "top-side-item"
  }, [(_vm.user_info.email) ? _c('a', {
    attrs: {
      "href": "/profile.html#/user"
    }
  }, [_vm._v(_vm._s(_vm.user_info.email))]) : _c('a', {
    attrs: {
      "href": "/profile.html#/login"
    }
  }, [_vm._v("登录")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(41)
    }
  })])
}]}

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container clearfix",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "bottom-desc"
  }, [_c('p', [_vm._v("职人联盟，找人雇猎头，就上OKLIE")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "copy-right"
  }, [_vm._v("©2020 oklie.cn. All Rights Reserved")])])])
}]}

/***/ })

},[125]);


// WEBPACK FOOTER //
// src/js/router.31dc5a30ca0736e5b3b2.js